import { render, staticRenderFns } from "./PlanningItemMobile.vue?vue&type=template&id=5c5dbb19&scoped=true&lang=pug&"
import script from "./PlanningItemMobile.vue?vue&type=script&lang=js&"
export * from "./PlanningItemMobile.vue?vue&type=script&lang=js&"
import style0 from "./PlanningItemMobile.vue?vue&type=style&index=0&id=5c5dbb19&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5dbb19",
  null
  
)

export default component.exports